import { NgModule } from "@angular/core";
import { NoPreloading, RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "../../../commons/src/lib/guards/auth.guard";
import { MenuGuard } from "../../../commons/src/lib/guards/menu.guard";
import type { LoadableModule } from "../../../commons/src/lib/models/types/loadable-module.type";

const routes: Routes = [
  { path: "", redirectTo: "home", pathMatch: "full" },
  {
    path: "home",
    loadChildren: () =>
      import("../../../home/src/app/home.module")
        .then((m: LoadableModule<typeof import("../../../home/src/app/home.module")>) => m.HomeModule)
        .catch((err: Error) => {
          console.error(`error loading home module :: ${err.message}`);
          return Promise.reject(err);
        }),
    canActivate: [AuthGuard],
    data: { breadcrumb: "Inicio / Ordenes Servicio Técnico" },
  },
  {
    path: "register-ost",
    loadChildren: () =>
      import("../../../register-ost/src/app/register-ost.module")
        .then((m: LoadableModule<typeof import("../../../register-ost/src/app/register-ost.module")>) => m.RegisterOstModule)
        .catch((err: Error) => {
          console.error(`error loading home module :: ${err.message}`);
          return Promise.reject(err);
        }),
    canActivate: [AuthGuard],
    data: { breadcrumb: "Inicio" },
  },
  {
    path: "detail-ost",
    loadChildren: () =>
      import("../../../detail-ost/src/app/ost-detail.module")
        .then((m: LoadableModule<typeof import("../../../detail-ost/src/app/ost-detail.module")>) => m.OstDetailModule)
        .catch((err: Error) => {
          console.error(`error loading home module :: ${err.message}`);
          return Promise.reject(err);
        }),
    canActivate: [AuthGuard],
    data: { breadcrumb: "Inicio / Ordenes Servicio Técnico" },
  },
  {
    path: "labels",
    loadChildren: () =>
      import("../../../labels/src/app/labels.module")
        .then((m: LoadableModule<typeof import("../../../labels/src/app/labels.module")>) => m.LabelsModule)
        .catch((err: Error) => {
          console.error(`error loading home module :: ${err.message}`);
          return Promise.reject(err);
        }),
    canActivate: [AuthGuard, MenuGuard],
    data: { breadcrumb: "Inicio", menuKey: "labels" },
  },
  {
    path: "excel-upload",
    loadChildren: () =>
      import("../../../excel-upload/src/app/excel-upload.module")
        .then((m: LoadableModule<typeof import("../../../excel-upload/src/app/excel-upload.module")>) => m.ExcelUploadModule)
        .catch((err: Error) => {
          console.error(`error loading excel upload module :: ${err.message}`);
          return Promise.reject(err);
        }),
    canActivate: [AuthGuard, MenuGuard],
    data: { breadcrumb: "Inicio", menuKey: "excel-upload" },
  },
  {
    path: "form-free",
    loadChildren: () =>
      import("../../../free-form/src/app/free-form.module")
        .then((m: LoadableModule<typeof import("../../../free-form/src/app/free-form.module")>) => m.FreeFormModule)
        .catch((err: Error) => {
          console.error(`error loading free form  module :: ${err.message}`);
          return Promise.reject(err);
        }),
    canActivate: [AuthGuard, MenuGuard],
    data: { breadcrumb: "Inicio", menuKey: "form-free" },
  },
  {
    path: "company-ost",
    loadChildren: () =>
      import("../../../company-ost/src/app/company-ost.module")
        .then((m: LoadableModule<typeof import("../../../company-ost/src/app/company-ost.module")>) => m.CompanyOstModule)
        .catch((err: Error) => {
          console.error(`error loading company ost module :: ${err.message}`);
          return Promise.reject(err);
        }),
    canActivate: [AuthGuard, MenuGuard],
    data: { breadcrumb: "Inicio", menuKey: "company-ost" },
  },
  {
    path: "branches",
    loadChildren: () =>
      import("../../../branches/src/app/branches/branches.module")
        .then((m: LoadableModule<typeof import("../../../branches/src/app/branches/branches.module")>) => m.BranchesModule)
        .catch((err: Error) => {
          console.error(`error loading branches module :: ${err.message}`);
          return Promise.reject(err);
        }),
    canActivate: [AuthGuard, MenuGuard],
    data: { breadcrumb: "Inicio", menuKey: "branches" },
  },
  { path: "**", redirectTo: "home" },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: NoPreloading,
    }),
  ],
  exports: [RouterModule],
})
export class AppRouting {}
